/** Assets estáticos do PHP (`asset('images/...')` → `/public/images/...`). */
export function pubImg(path: string): string {
  const rel = path.replace(/^\/?(public\/)?/, '')
  return `/public/${rel}`
}
